import React from 'react';
import useGetNFTCollection from '../../data/useGetNFTCollection';
import { INFTHistoryItem } from '../../models/INFTHistory';
import ActivityDetail from './ActivityDetail';
import AvawareAllenActivtyDetail from './AvawareAllenActivtyDetail';
import AVAXBrosNFTActivityDetail from './AVAXBrosNFTActivityDetail';
import AvaxCatsActivityDetail from './AvaxCatsActivityDetail';
import AvaxcellsActivityDetail from './AvaxcellsActivityDetail';
import AvaxtarsActivtyDetail from './AvaxtarsActivityDetail';
import ChillAFSlothsActivtyDetail from './ChillAFSlothsActivtyDetail';
import CryptoDappersActivtyDetail from './CryptoDappersActivtyDetail';
import CryptoSealActivtyDetail from './CryptoSealActivtyDetail';
import CryptoWaifusActivtyDetail from './CryptoWaifusActivtyDetail';
import DeproApeCryptoClubActivtyDetail from './DeproApeCryptoClubActivtyDetail';
import GeneralActivityDetail from './GeneralActivityDetail';
import HatchyPocketActivtyDetail from './HatchyPocketActivtyDetail';
import HeroesOfNFTActivtyDetail from './HeroesOfNFTActivtyDetail';
import HuskyNFTActivtyDetail from './HuskyNFTActivtyDetail';
import LootFishActivityDetail from './LootFishActivityDetail';
import NeonMonstersActivityDetail from './NeonMonstersActivityDetail';
import NovaXActivtyDetail from './NovaXActivtyDetail';
import PudgyPenguinsActivityDetail from './PudgyPenguinsActivityDetail';
import SkiptNFTActivityDetail from './SkiptNFTActivtyDetail';
import SnowBallActivtyDetail from './SnowBallActivtyDetail';
import SporeActivtyDetail from './SporeActivtyDetail';

export const defaultCollection = {
    id: 'yetiswapCollection',
    tokenAddress: '0xc01b3e9678c73A96BA51d040ce435d1c28fd1E1d',
    name: 'YetiSwap Collection',
    category: 0,
    creatorAddress: '',
    cardFormat: "DefaultCard",
    detailFormat: "ActivityDetail",
    activityFormat: "ActivityDetail"
}


export default function NFTActivityFormater(props: INFTHistoryItem): JSX.Element {
    const { tokenContract } = props.historyItem

    const foundedCollection: any = useGetNFTCollection(tokenContract);

    const getNFTActivity = React.useCallback((activityFormat: string, _props: any) => {
        switch (activityFormat) {
            case "GeneralActivityDetail": {
                return <GeneralActivityDetail key={_props.historyItem.id} {..._props} />
            }
            case "AvawareAllenActivtyDetail": {
                return <AvawareAllenActivtyDetail key={_props.historyItem.id} {..._props} />
            }
            case "AVAXBrosNFTActivityDetail": {
                return <AVAXBrosNFTActivityDetail key={_props.historyItem.id} {..._props} />
            }
            case "AvaxCatsActivityDetail": {
                return <AvaxCatsActivityDetail key={_props.historyItem.id} {..._props} />
            }
            case "AvaxcellsActivtyDetail": {
                return <AvaxcellsActivityDetail key={_props.historyItem.id} {..._props} />
            }
            case "AvaxtarsActivtyDetail": {
                return <AvaxtarsActivtyDetail key={_props.historyItem.id} {..._props} />
            }
            case "ChillAFSlothsctivtyDetail": {
                return <ChillAFSlothsActivtyDetail key={_props.historyItem.id} {..._props} />
            }
            case "CryptoDappersActivtyDetail": {
                return <CryptoDappersActivtyDetail key={_props.historyItem.id}{..._props} />
            }
            case "CryptoSealActivtyDetail": {
                return <CryptoSealActivtyDetail key={_props.historyItem.id}{..._props} />
            }
            case "CryptoWaifusActivtyDetail": {
                return <CryptoWaifusActivtyDetail key={_props.historyItem.id}{..._props} />
            }
            case "DeproApeCryptoClubActivtyDetail": {
                return <DeproApeCryptoClubActivtyDetail key={_props.historyItem.id} {..._props} />
            }
            case "HatchyPocketActivtyDetail": {
                return <HatchyPocketActivtyDetail key={_props.historyItem.id}{..._props} />
            }
            case "HeroesOfNFTActivtyDetail": {
                return <HeroesOfNFTActivtyDetail key={_props.historyItem.id}{..._props} />
            }
            case "HuskyNFTActivtyDetail": {
                return <HuskyNFTActivtyDetail key={_props.historyItem.id}{..._props} />
            }
            case "LootFishActivityDetail": {
                return <LootFishActivityDetail key={_props.historyItem.id} {..._props} />
            }
            case "NeonMonstersActivityDetail": {
                return <NeonMonstersActivityDetail key={_props.historyItem.id} {..._props} />
            }
            case "NovaXActivtyDetail": {
                return <NovaXActivtyDetail key={_props.historyItem.id}{..._props} />
            }
            case "PudgyPenguinsActivityDetail": {
                return <PudgyPenguinsActivityDetail key={_props.historyItem.id}{..._props} />
            }
            case "SkiptNFTActivityDetail": {
                return <SkiptNFTActivityDetail key={_props.historyItem.id}{..._props} />
            }
            case "SporeActivtyDetail": {
                return <SporeActivtyDetail key={_props.historyItem.id}{..._props} />
            }
            case "SnowBallActivtyDetail": {
                return <SnowBallActivtyDetail key={_props.historyItem.id}{..._props} />
            }
            case "ActivityDetail":
            default: {
                return <ActivityDetail key={_props.historyItem.id}{..._props} />
            }
        }
    }, []);

    return getNFTActivity(foundedCollection ? foundedCollection.activityFormat : defaultCollection.activityFormat, {
        historyItem: props.historyItem,
        chainId: props.chainId,
        collection: foundedCollection ?? defaultCollection
    });
}
